import React, { useState } from 'react';
import './style/Course.css';
import banner from '../assets/course_banner.png';
import play from '../assets/Group 9.png';

const Cource = () => {
  const [activeTab, setActiveTab] = useState('All Courses');

  const tabs = ['All Courses', 'Web Development', 'App Development', 'UI/UX', 'Data Analysis'];

  const renderContent = () => {
    const bgColors = ['#FFEDD5', '#DBEAFE', '#DCFCE7', '#FCE7F3', '#FEF9C3', '#E0F2FE', '#F3E8FF', '#FFE4E6'];
  
    const getRandomColor = () => {
      return bgColors[Math.floor(Math.random() * bgColors.length)];
    };
  
    const courseData = {
      'All Courses': [
        {
          title: 'Web Development',
          desc: 'Learn HTML, CSS, JavaScript, React, and more!',
        },
        {
          title: 'App Development',
          desc: 'Master Android, iOS, Flutter, and React Native.',
        },
        {
          title: 'UI/UX',
          desc: 'Design stunning interfaces with Figma, XD & best UX practices.',
        },
        {
          title: 'Data Analysis',
          desc: 'Dive into Python, SQL, Excel, Power BI, and data storytelling.',
        },
      ],
      'Web Development': [
        {
          title: 'HTML',
          desc: 'Learn the structure of web pages using HTML5. Master tags, forms, tables, and semantic elements.',
          image: require('../assets/course/HTML.png'),
        },
        {
          title: 'CSS',
          desc: 'Style beautiful websites with CSS3, Flexbox, Grid, animations, and responsive design techniques.',
          image: require('../assets/course/css.png'),
        },
        {
          title: 'JavaScript',
          desc: 'Make your sites interactive using JavaScript. Understand DOM manipulation, ES6, and event handling.',
         
        },
        {
          title: 'React',
          desc: 'Build modern web apps with React. Learn components, hooks, props, state, and how to manage routing.',
        }
      ],
      'App Development': [
        {
          title: 'App Development',
          desc: 'Master Android, iOS, Flutter, and React Native.',
        },
      ],
      'UI/UX': [
        {
          title: 'UI/UX Design',
          desc: 'Design stunning interfaces with Figma, XD & best UX practices.',
        },
      ],
      'Data Analysis': [
        {
          title: 'Data Analysis',
          desc: 'Dive into Python, SQL, Excel, Power BI, and data storytelling.',
        },
      ],
    };
  
    return (
      <div className="card-container">
        {courseData[activeTab]?.map((course, index) => (
          <div
            key={index}
            className="course-card"
            style={{ backgroundColor: getRandomColor() }}
          >
            {course.image && (
              <img
                src={course.image}
                alt={course.title}
                className="course-img"
              />
            )}
            <div style={{padding: '1rem'}}>
              <h2>{course.title}</h2>
              <p>{course.desc}</p>
            </div>
            
          </div>
        ))}
      </div>
    );
  };
  

  return (
    <>
      <div className='course_banner'>
        <div className='course_banner_text'>
          <h1 className='course_banner_h1'>
            💡 Unlock Your Potential with Zest Pack Technology.
          </h1>
          <h2 className='course_banner_h2'>Grow your skills, anytime, anywhere.</h2>
          <p className='course_banner_p'>
            Join our expert-led online courses and dive into the
            world of Web Development, App Development, Data Analysis,
            Cybersecurity, and more. Whether you're a beginner or looking
            to upskill, Zest Pack Technology empowers your learning journey
            with real-world projects and hands-on experience.
          </p>
          <h3 className='course_banner_h3'>🚀 Learn. Build. Grow.</h3>
          <h3 className='course_banner_h4'>🎓 Start your journey today with Zest Pack Technology – Where Innovation Meets Education.</h3>
        </div>
        <div className='course_banner_img'>
          <img src={banner} alt="Image not Found" />
        </div>
      </div>

      <div className="play_img">
        <img src={play} alt="Image not found" />
      </div>

      <div className='Popular'>
        <h1 className='Popular_h1'>Popular Courses</h1>
      </div>

      <div className="tab-container">
        <div className="tab-buttons">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={activeTab === tab ? 'active' : ''}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="tab-content">
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default Cource;